import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import AppSidebar from './components/AppSidebar.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// Import AdminLTE assets
import 'admin-lte/dist/css/adminlte.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-lte/plugins/fontawesome-free/css/all.min.css'

import 'admin-lte/plugins/jquery/jquery.min.js'
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import 'admin-lte/dist/js/adminlte.min.js'

import $ from "jquery"
window.$ = $
window.jQuery = $
createApp(App).use(router).component('AppSidebar', AppSidebar).mount('#app')
